module.exports = __webpack_public_path__ + "static/media/productos_botanas_cacahuate_bufalo.73cd2331.png";